// ko strings for messages/auth.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const auth: Dict = {
  // Shared
  "auth.continueGoogle": "Google로 계속하기",
  "auth.orEmail": "또는 이메일로",
  "auth.email": "이메일",
  "auth.emailInput": "이메일 입력",
  "auth.emailPlaceholder": "you@example.com",
  "auth.password": "비밀번호",
  "auth.passwordInput": "비밀번호 입력",
  "auth.passwordPlaceholderNew": "6자 이상",
  "auth.signUp": "회원가입",
  "auth.logIn": "로그인",
  "auth.signIn": "로그인",
  "auth.createAccount": "계정 만들기",
  "auth.createYourAccount": "계정 만들기",
  "auth.forgotPassword": "비밀번호를 잊으셨나요?",
  "auth.agree": "다음에 동의합니다:",
  "auth.agreeJammable": "Jammable의 다음 항목에 동의합니다:",
  "auth.and": "및",
  "auth.terms": "이용약관",
  "auth.privacy": "개인정보처리방침",
  "auth.agreeRequired": "이용약관과 개인정보처리방침에 동의해 주세요.",
  "auth.welcomeBack": "다시 오신 걸 환영해요!",
  "auth.welcomeNew": "Jammable에 오신 걸 환영해요!",
  "auth.registerError": "가입 중 오류가 발생했어요. 다시 시도해 주세요.",
  "auth.backToLogin": "로그인으로 돌아가기",

  // Form validation
  "auth.invalidEmail": "올바르지 않은 이메일이에요",
  "auth.emailRequired": "이메일을 입력해 주세요",
  "auth.passwordMin": "비밀번호는 6자 이상이어야 해요",
  "auth.passwordRequired": "비밀번호를 입력해 주세요",

  // SignInModal
  "auth.modal.signInTitle": "Jammable 로그인",
  "auth.modal.subtitle": "10만 개 이상의 목소리로 AI 커버를 만들어 보세요.",
  "auth.modal.signUpButton": "회원가입 버튼",
  "auth.modal.signInButton": "로그인 버튼",
  "auth.modal.haveAccount": "계정이 있으신가요?",
  "auth.modal.newHere": "처음이신가요?",
  "auth.modal.createAnAccount": "계정 만들기",

  // /login
  "auth.login.heading": "다시 오신 걸 환영해요",
  "auth.login.blurb": "커버, 목소리, 컬렉션이 그대로 기다리고 있어요.",
  "auth.login.noAccount": "계정이 없으신가요?",

  // /signup: "<heading> <highlight>"
  "auth.signup.heading": "어떤 목소리로든 노래하는",
  "auth.signup.headingHighlight": "내 오디오",
  "auth.signup.blurb":
    "10만 개 이상의 목소리, 한곳에 저장되는 커버, 듀엣과 영상을 만드는 스튜디오까지.",
  "auth.signup.haveAccount": "이미 계정이 있으신가요?",

  // /forgotpassword
  "auth.forgot.title": "비밀번호 재설정",
  "auth.forgot.blurb":
    "이메일을 입력하면 새 비밀번호를 설정할 수 있는 링크를 보내 드려요.",
  "auth.forgot.send": "재설정 링크 보내기",
  "auth.forgot.sentToast": "비밀번호 재설정 이메일을 보냈어요!",
  "auth.forgot.sent": "보냈어요. 받은편지함과 스팸함을 확인해 주세요.",
  "auth.forgot.google": "Google로 가입하셨나요?",
  "auth.forgot.googleAfter": "",

  // /resetpassword
  "auth.reset.title": "새 비밀번호 설정",
  "auth.reset.blurb": "6자 이상으로 정해 주세요. 다음 로그인부터 사용해요.",
  "auth.reset.newPassword": "새 비밀번호",
  "auth.reset.submit": "비밀번호 재설정",
  "auth.reset.success": "비밀번호가 재설정되었어요!",
  "auth.reset.expired": "링크가 만료되었나요?",
  "auth.reset.sendNew": "새 링크 받기",

  // Firebase errors: Google popup
  "auth.error.google.popup-closed-by-user":
    "로그인을 마치기 전에 팝업 창이 닫혔어요. 다시 시도해 주세요.",
  "auth.error.google.popup-blocked":
    "브라우저가 팝업 창을 차단했어요. 팝업을 허용한 뒤 다시 시도해 주세요.",
  "auth.error.google.operation-not-supported-in-this-environment":
    "현재 환경에서는 이 로그인 방식을 지원하지 않아요.",
  "auth.error.google.network-request-failed":
    "네트워크 오류가 발생했어요. 인터넷 연결을 확인하고 다시 시도해 주세요.",
  "auth.error.google.cancelled-popup-request":
    "로그인 요청이 여러 번 감지되었어요. 다시 시도해 주세요.",
  "auth.error.google.timeout":
    "로그인 시간이 너무 오래 걸렸어요. 인터넷 연결을 확인하고 다시 시도해 주세요.",
  "auth.error.google.account-exists-with-different-credential":
    "이 이메일 주소로 가입된 계정이 이미 있어요. 가입할 때 사용한 방식으로 로그인해 주세요.",
  "auth.error.google.invalid-credential":
    "로그인 정보가 올바르지 않거나 만료되었어요. 다시 시도해 주세요.",
  "auth.error.google.user-disabled":
    "계정이 비활성화되었어요. 고객지원에 문의해 주세요.",
  "auth.error.google.user-not-found":
    "이 이메일 주소로 가입된 계정이 없어요. 다시 시도하거나 새 계정을 만들어 주세요.",
  "auth.error.google.wrong-password":
    "비밀번호가 올바르지 않아요. 다시 시도해 주세요.",

  // Firebase errors: email sign-in
  "auth.error.signIn.invalid-email":
    "입력한 이메일 주소가 올바르지 않아요. 확인 후 다시 시도해 주세요.",
  "auth.error.signIn.user-disabled":
    "계정이 비활성화되었어요. 고객지원에 문의해 주세요.",
  "auth.error.signIn.user-not-found":
    "이 이메일 주소로 가입된 계정이 없어요. 다시 시도하거나 새 계정을 만들어 주세요.",
  "auth.error.signIn.wrong-password":
    "입력한 비밀번호가 올바르지 않아요. 다시 시도해 주세요.",
  "auth.error.signIn.too-many-requests":
    "로그인 실패 횟수가 너무 많아요. 잠시 후 다시 시도해 주세요.",

  // Firebase errors: email sign-up
  "auth.error.signUp.email-already-in-use":
    "이미 다른 계정에서 사용 중인 이메일 주소예요. 다른 이메일을 사용해 주세요.",
  "auth.error.signUp.invalid-email":
    "입력한 이메일 주소가 올바르지 않아요. 확인 후 다시 시도해 주세요.",
  "auth.error.signUp.operation-not-allowed":
    "현재 새 계정을 만들 수 없어요. 잠시 후 다시 시도해 주세요.",
  "auth.error.signUp.weak-password":
    "비밀번호는 6자 이상이어야 해요. 더 안전한 비밀번호를 사용해 주세요.",

  // Firebase errors: sending the reset email
  "auth.error.forgot.invalid-email": "올바른 이메일 주소를 입력해 주세요.",
  "auth.error.forgot.user-not-found": "이 이메일로 가입된 계정이 없어요.",
  "auth.error.forgot.missing-android-pkg-name":
    "Android 패키지 이름이 필요해요.",
  "auth.error.forgot.missing-continue-uri": "계속 URL이 필요해요.",
  "auth.error.forgot.missing-ios-bundle-id": "iOS 번들 ID가 필요해요.",
  "auth.error.forgot.unauthorized-continue-uri":
    "허용되지 않은 계속 URL이에요.",
  "auth.error.forgot.operation-not-allowed":
    "이 프로젝트에서는 비밀번호 재설정을 사용할 수 없어요.",

  // Firebase errors: setting the new password
  "auth.error.reset.invalid-action-code":
    "인증 코드가 올바르지 않아요. 링크를 확인하고 다시 시도해 주세요.",
  "auth.error.reset.expired-action-code":
    "인증 코드가 만료되었어요. 비밀번호 재설정 이메일을 다시 요청해 주세요.",
  "auth.error.reset.user-disabled":
    "이 계정은 비활성화되었어요. 고객지원에 문의해 주세요.",
  "auth.error.reset.user-not-found": "이 이메일로 가입된 계정이 없어요.",
  "auth.error.reset.weak-password": "비밀번호는 6자 이상이어야 해요.",
  "auth.error.reset.operation-not-allowed":
    "이 프로젝트에서는 비밀번호 재설정을 사용할 수 없어요.",
  "auth.seo.loginTitle": "로그인 - Jammable",
  "auth.seo.loginDescription": "Jammable 계정에 로그인하세요.",
  "auth.seo.signupTitle": "회원가입 | Jammable",
};

export default auth;
